/**
 * @param {MatchData} match
 * @returns {string|undefined}
 */
export default function getTagFromMatchRouteUtil (match) {
  const tag = match?.params?.tag?.toLowerCase()
  if (!tag) {
    return
  }

  return tag.replace(/-/g, ' ')
}
